import { useState, useEffect, useContext } from "react";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { BusinessManagerContext } from "src/contexts/BusinessManagerContext";

function AchievedAndExpectedResults(props) {
    const { t } = useTranslation();
    const { eepBMData } = useContext(BusinessManagerContext);
    const isVisu = props.isVisu;
    const [data, setData] = useState({
        rPlus: 0,
        sign: 0,
        oc: 0
    });

    useEffect(() => {
        if (props.data != undefined) {
            setData({
                rPlus: props.data.rPlus,
                sign: props.data.sign,
                oc: props.data.oc
            })
        }
    }, [props.data]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const setDataContextValue = () => {
        eepBMData.rPlus = parseInt(data.rPlus + "");
        eepBMData.sign = parseInt(data.sign + "");
        eepBMData.oc = parseInt(data.oc + "");
    }
    return (
        <div style={{ marginTop: 15 }} >
            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell align="center">R+</TableCell>
                            <TableCell align="center">Sign.</TableCell>
                            <TableCell align="center">OC</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key={t('eepBm.tableResult.label1')} style={{ height: 40 }}>
                            <TableCell component="th" scope="row" style={{ paddingLeft: 10 }}><b><Trans>eepBm.tableResult.label1</Trans></b></TableCell>
                            <TableCell align="center">
                                <TextField
                                    label=""
                                    type="number"
                                    name="rPlus"
                                    value={data.rPlus}
                                    variant="standard"
                                    style={{
                                        width: 45
                                    }}
                                    inputProps={{
                                        min: 0,
                                        style: { textAlign: 'right' }
                                    }}
                                    disabled={isVisu}
                                    onChange={handleChange}
                                    onBlur={setDataContextValue}
                                />
                            </TableCell>
                            <TableCell align="center">
                                <TextField
                                    label=""
                                    type="number"
                                    name="sign"
                                    value={data.sign}
                                    variant="standard"
                                    style={{
                                        width: 45
                                    }}
                                    inputProps={{
                                        min: 0,
                                        style: { textAlign: 'right' }
                                    }}
                                    disabled={isVisu}
                                    onChange={handleChange}
                                    onBlur={setDataContextValue}
                                />
                            </TableCell>
                            <TableCell align="center">
                                <TextField
                                    label=""
                                    type="number"
                                    name="oc"
                                    value={data.oc}
                                    variant="standard"
                                    style={{
                                        width: 45
                                    }}
                                    inputProps={{
                                        min: 0,
                                        style: { textAlign: 'right' }
                                    }}
                                    disabled={isVisu}
                                    onChange={handleChange}
                                    onBlur={setDataContextValue}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow key={t('eepBm.tableResult.label2')} style={{ height: 40 }}>
                            <TableCell component="th" scope="row" style={{ paddingLeft: 10 }}><b><Trans>eepBm.tableResult.label2</Trans></b></TableCell>
                            <TableCell align="center">12</TableCell>
                            <TableCell align="center">7</TableCell>
                            <TableCell align="center">1</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <div></div>
        </div>
    );
}

export default AchievedAndExpectedResults;